import React from 'react';
import { CircleCheckIcon } from 'lucide-react';
import { instantItems } from '../data/content';
export function InstantAccess() {
  return <section className="w-full bg-cream px-5 py-20 sm:py-28" data-id="element-137" data-mp="2582nt2k0r622">
      <div className="mx-auto max-w-2xl" data-id="element-138" data-mp="1r9uhw5508uer">
        <h2 className="text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-139" data-mp="1r8t4hu0invtv">
          What Do You Get Instantly?
        </h2>

        <ul className="mt-10 space-y-3" data-id="element-140" data-mp="1hhot14a1ut3s">
          {instantItems.map(item => <li key={item} className="flex items-center gap-3 rounded-xl bg-white px-5 py-4 text-sm font-medium text-ink/85" data-id="element-141" data-mp="1mb1ex6ncglsu">
              <CircleCheckIcon className="h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-142" data-mp="1cjx0q95ht4z2" />
              {item}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display text-lg font-bold italic text-brand sm:text-xl" data-id="element-143" data-mp="13j8mbdc6t2ln">
          You cover the full skill spectrum for all ages in one click.
        </p>
      </div>
    </section>;
}